

















import { Component, Vue } from 'vue-property-decorator';
import AuthService from "../services/AuthService";

@Component({
    components: {
    },
})
export default class Confirmation extends Vue {

    // ?u=sergio-1&t=fOmaGAUwzxQRWY8KE4AS4qIZ0ccZbxV6DlVbEDDYwcQ
    private authService = new AuthService();
    private success = false;

    private get token() {
        return this.$route.query['t']
    }

    private get user() {
        return this.$route.query['u']
    }

    async mounted() {
        await this.confirmUser();
    }

    private async confirmUser() {
        try {
            await this.authService.confirm({
                username: this.user,
                token: this.token,
                currency: "EUR",
                url: "https://golagol.com/lobby"
            });
            this.success = true;
        } catch (e) {
            console.log(e);
        }
    }

    private goTo(path: string) {
        this.$router.push(path)
    }
}
